/**
 * This file is auto-generated from the Makefile command: 'sync-frontend-constants'.
 * If you'd like to update the types included here, make a change to
 * eve/apps/core/management/commands/generate_frontend_constants.py and run 'sync-frontend-constants'
 * */
export enum LOCTypeEnum {
  ACTIVE_ADULT = 'Active Adult 55 + Community',
  ADULT_DAY_CENTER = 'Adult Day Center',
  AFFORDABLE_HOUSING = 'Affordable Housing',
  AREA_AGENCY_ON_AGING = 'Area Agency on Aging government entity or a similar nonprofit (senior center)',
  ASSISTED_LIVING = 'Assisted Living',
  CLINIC = 'Clinic(primary care, dental, etc.)',
  CORPORATE = 'Corporate',
  GREEN_HOUSES = 'Green Houses',
  HOME_CARE = 'Home Care',
  HOME_HEALTH = 'Home Health',
  HOME_MEDICAL_EQUIPMENT = 'Home Medical Equipment',
  HOSPICE = 'Hospice',
  HOSPITAL = 'Hospital',
  INDEPENDENT_LIVING = 'Independent Living',
  IRF = 'IRF: hospital - based rehab',
  MEMORY_CARE = 'Memory Care',
  MENTAL_HEALTH = 'Mental Health / Disability Services',
  NON_MEDICAL_HOME_CARE = 'Non - medical home care',
  PHARMACY = 'Pharmacy',
  PROGRAM_FOR_ELDERLY = 'Program for All Inclusive Care for the Elderly',
  RESIDENTIAL_CARE = 'Residential care homes / households',
  SKILLED_NURSING_LT_CARE = 'Skilled Nursing: Long term care',
  SKILLED_NURSING_REHAB = 'Skilled Nursing: Short-term rehab',
  THERAPY = 'Therapy',
  VALUE_BASED = 'Value-Based/Capitated Care',
  OTHER = 'Other',
}
export enum ResidentRespondentTypeEnum {
  RESIDENT = 'Resident',
  PAST_RESIDENT = 'Past Resident',
  PRIMARY_CONTACT = 'Primary Contact',
  SECONDARY_CONTACT = 'Secondary Contact',
  ADDITIONAL_CONTACT = 'Additional Contact',
}
export enum WorkStatusEnum {
  FULL_TIME = 'Full-time',
  PART_TIME = 'Part-time',
  PER_DIEM = 'Per diem or PRN',
}
export enum DTypeEnum {
  SERVICE_COORDINATOR = 'Service/Care Coordinator',
  CORPORATE = 'Corporate',
  ADMINISTRATION = 'Administration',
  ENVIRONMENTAL_SERVICES = 'Environmental Services',
  CAREGIVING = 'Caregiving',
  ACTIVITIES = 'Activities, Social Work, Spiritual, Concierge or Desk',
  CLINIC = 'Clinician',
  MEDICATIONS_TECHNICIAN = 'Medications Technician',
  PLANT_OPS = 'Plant Ops',
  DINING_FRONT = 'Dining - Front (Waitstaff, Admin)',
  DINING_KITCHEN = 'Dining - Kitchen',
  DRIVERS = 'Drivers',
  LICENSED_NURSING = 'Licensed Nursing',
  PHARMACIST = 'Pharmacist',
  PHARMACY_TECHNICIAN = 'Pharmacy Technician',
  PHARMACY_SUPPORT = 'Pharmacy Support',
  THERAPIST = 'Therapist',
  THERAPY_ASSISTANT = 'Therapy Assistant',
}
export enum CertificationStatusEnum {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  CERTIFIED = 'Certified',
  CERTIFIED_EXPIRED = 'Certified Expired',
  NOT_CERTIFIED = 'Not Certified',
  NOT_CERTIFIED_EXPIRED = 'Not Certified Expired',
  ACCESS_EXPIRED = 'Access Expired',
}
export enum CultureBriefStatusEnum {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  IMPORTED_EMPTY = 'Imported Empty',
}
export enum IndustrySubVerticalEnum {
  SENIOR_HOUSING = 'Senior Housing & Care',
  AT_HOME_CARE = 'At-Home Care',
}
export enum OrganizationTypeEnum {
  FOR_PROFIT = 'For Profit',
  NOT_FOR_PROFIT = 'Not for Profit',
}
export enum CertificationTypeEnum {
  NONE = 'None',
  ORGANIZATION_LEVEL = 'Organization Level',
  LOCATION_LEVEL = 'Location Level',
}
export enum UserAppMessageEnum {
  SURVEY_CERTIFICATION = 'Survey Certification',
  VIEW_INDIVIDUAL_RESULTS = 'View Individual Results',
}
export enum EmployeeBenefitsEnum {
  TRANSPORTATION_STIPEND = 'Transportation stipend',
  SAME_DAY_PAY = 'Same-day pay',
  EMERGENCY_TRANSPORTATION_ASSISTANCE = 'Emergency transportation assistance',
  AUTOMATED_SELF_SCHEDULING = 'Automated self-scheduling',
  CHILDCARE_STIPEND = 'Childcare stipend',
  ENGLISH_CLASSES = 'English Second Language classes',
  EMERGENCY_BACKUP = 'Emergency backup childcare',
  TUITION_REIMBURSMENT = 'Tuition reimbursement',
  ONSITE_DAY_CARE = 'Onsite day care',
  DEGREE_PROGRAM = 'Associate or college degree program',
  _401k = '401k',
}
export enum ResidentReasonsForLeavingEnum {
  NEEDED_MORE_CARE = 'Needed more care',
  CLOSER_TO_LOVED_ONES = 'Location closer to loved ones',
  RAN_OUT_OF_MONEY = 'Ran out of money',
  DISSATISFIED_WITH_CARE = 'Dissatisfied with care',
  DISSATISFIED_WITH_PRICE = 'Dissatisfied with price',
  OTHER = 'Other',
  REQUESTED_BY_FACILITY_OR_UNKNOWN = 'Facility’s request/unknown reason',
  DEATH = 'Death',
  MOVED_TO_HOSPICE = 'Moved to Hospice',
  COMPLETED_CARE = 'Completed care',
  HOSPITALIZED = 'Hospitalized',
}
export enum EmployeeReasonsForLeavingEnum {
  LAID_OFF = 'Laid Off',
  RESIGNED = 'Resigned',
  PERSONAL_MATTERS = 'Family/personal matters',
  TERMINATED = 'Terminated',
  NEW_JOB = 'New Job',
  OTHER = 'Other',
}
export enum GraphQLErrorsEnum {
  UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS',
  FORBIDDEN = 'FORBIDDEN',
}
export enum PhoneScriptTagsEnum {
  LOCATION_NAME = 'location_name',
  OUR_COMPANY_NAME = 'our_company_name',
  ORGANIZATION_NAME = 'organization_name',
  PARTICIPANT_NAME = 'participant_name',
  SRC_FIRST_NAME = 'src_first_name',
  SURVEY_TYPE_NAME = 'survey_type_name',
  CLIENT_NAME = 'client_name',
}
export enum ParticipantTypeOptionsEnum {
  CLIENT = 'Client',
  REPRESENTATIVE = 'Representative',
  ALL = 'All',
}
export enum HttpContentTypeEnum {
  XLS_MIME_TYPE = 'application/vnd.ms-excel',
  XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
}
export enum SurveyTypes {
  ALWAYS_OPEN_ENDED = '["MONTHLY","END_OF_EMPLOYMENT","RESIDENT_ENGAGEMENT_MONTHLY","RESIDENT_START_OF_SERVICE","RESIDENT_END_OF_SERVICE","RESIDENT_DISCHARGE"]',
  ALWAYS_WITH_AN_END_DATE = '["TI","PULSE","RESIDENT_ENGAGEMENT","RESIDENT_PULSE"]',
  ALLOWED_TO_BE_OPEN_LINK = '["RESIDENT_ENGAGEMENT","RESIDENT_END_OF_SERVICE","RESIDENT_DISCHARGE","RESIDENT_CUSTOM"]',
}
